export default "__VITE_ASSET__BD8jJt0A__$_?url__"